/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'group-solid': {
    width: 16,
    height: 16,
    viewBox: '0 0 25 25',
    data: '<circle pid="0" cx="13" cy="4" r="3"/><circle pid="1" cx="20" cy="3" r="3"/><circle pid="2" cx="6" cy="3" r="3"/><path pid="3" d="M7 16.5V13a5.987 5.987 0 0 1 2.31-4.721A4.979 4.979 0 0 0 1 12v2.5A1.5 1.5 0 0 0 2.5 16H3v4.5A1.5 1.5 0 0 0 4.5 22h3A1.5 1.5 0 0 0 9 20.5v-1.55a2.505 2.505 0 0 1-2-2.45zM20 7a4.96 4.96 0 0 0-3.31 1.279A5.987 5.987 0 0 1 19 13v3.5a2.505 2.505 0 0 1-2 2.45v1.55a1.5 1.5 0 0 0 1.5 1.5h3a1.5 1.5 0 0 0 1.5-1.5V16h.5a1.5 1.5 0 0 0 1.5-1.5V12a5 5 0 0 0-5-5z"/><path pid="4" d="M18 16.5V13a5 5 0 1 0-10 0v3.5A1.5 1.5 0 0 0 9.5 18h.5v5.5a1.5 1.5 0 0 0 1.5 1.5h3a1.5 1.5 0 0 0 1.5-1.5V18h.5a1.5 1.5 0 0 0 1.5-1.5z"/>'
  }
})
